var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDismissGuard } from '../../customHooks/useDismissGuard';
import TabTrap from '../../../helpers/TabTrap';
import { ModalContent, ModalContentWrapper, ModalWrapper, Overlay } from './subcomponents';
import { shouldDisableDismissGuard } from '../SimpleModalPortal/helpers';
export const setKeyboardFocus = (elementId, previousElement) => {
    if (elementId && document.getElementById(elementId)) {
        document.getElementById(elementId).focus();
    }
    else if (previousElement) {
        // if previousElement is not focusable, it seems to pass focus back to the body
        previousElement.focus();
    }
};
const SlideInModalPortal = (_a) => {
    var { ariaLabel = 'slide-in-modal-portal', id, isOpen, escapeModalHandler, children, header, className, footer, containerId, shadowRootContainerId, modalTriggerId } = _a, props = __rest(_a, ["ariaLabel", "id", "isOpen", "escapeModalHandler", "children", "header", "className", "footer", "containerId", "shadowRootContainerId", "modalTriggerId"]);
    const [postAnimationState, setPostAnimationState] = useState(false);
    const containerRef = useRef(null);
    const modalRef = useRef(null);
    /** when ShadowRoot Container Prop is passed, parent Element will be altered to be shadowRoot */
    const parentElement = (shadowRootContainerId &&
        document
            .getElementById(shadowRootContainerId)
            .shadowRoot.getElementById(containerId)) ||
        document.getElementById(containerId) ||
        document.body;
    const { onPointerDown, onPointerUp } = useDismissGuard({
        refs: modalRef,
        onDismiss: escapeModalHandler,
        disableGuard: shouldDisableDismissGuard()
    });
    useEffect(() => {
        /** Since Modal also injected into Shadow Root , it can be retrieved by below change */
        let modal = document.getElementById(id);
        if (shadowRootContainerId && !modal) {
            modal = document
                .getElementById(shadowRootContainerId)
                .shadowRoot.getElementById(id);
        }
        if (isOpen && !postAnimationState) {
            if (modal)
                modal.style.right = '0px';
            document.body.style.overflow = 'hidden';
            setPostAnimationState(true);
        }
        if (!isOpen && postAnimationState) {
            // Remove overflow hidden after modal closes
            document.body.style.removeProperty('overflow');
            if (modal) {
                modal.style.right = '-768px';
            }
            const previousElement = containerRef.current
                .previousElementSibling;
            setKeyboardFocus(modalTriggerId, previousElement);
            setTimeout(() => {
                setPostAnimationState(false);
            }, 400);
        }
        return () => {
            // Clean up overflow style during unmount
            document.body.style.removeProperty('overflow');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, shadowRootContainerId]);
    return createPortal(_jsx(Overlay, Object.assign({ isOpen: postAnimationState, ref: containerRef, onPointerDown: onPointerDown, onPointerUp: onPointerUp, "data-testid": `slide-in-modal-overlay-${id}` }, { children: (isOpen || postAnimationState) && (_jsx(TabTrap, { children: _jsxs(ModalWrapper, Object.assign({}, props, { id: id, ariaLabel: ariaLabel, escapeModalHandler: escapeModalHandler, "aria-hidden": !isOpen, className: className, modalRef: modalRef }, { children: [!!header && header, _jsx(ModalContentWrapper, { children: _jsx(ModalContent, Object.assign({ hasFooter: !!footer }, { children: children })) }), !!footer && footer] })) })) })), parentElement);
};
export default SlideInModalPortal;
//# sourceMappingURL=SlideInModalPortal.js.map